import React, { Component, memo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Notificacion } from '../../components/Util/Notificacion/Notificacion';
import { SiteRutas } from '../../request/RutasConfig';
import { Obtener_Conteo_Ordenes_Request } from '../../request/CallCenterMonitorRequest';
import { Tabs, Tab, Accordion, Card, Button } from 'react-bootstrap';
import TabPanelBody from '../../components/Body/CallCenterMonitor/Orden/TabPanel/TabPanelBody/TabPanelBody';
import Contador from '../../components/UI/KPI/Contador/Contador';
import Chart from '../../components/Body/CallCenterMonitor/Orden/Chart/Chart';

class OrdenesPage extends Component {
    _isMounted = false;
    state = {
        contador: {
            A_Tiempo: 0,
            Tiempo_Medio: 0,
            Retrasadas: 0,
            Total: 0
        },
        tabActivo: 'pendientes',
        debeRefrescar: false
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.existenParametros()) {
            this.obtenerContadores();
            if (this.props.location.state) {
                const parametros = { ...this.props.location.state };
                if (parametros && parametros.tab) {
                    let tabActivo = '';
                    switch (parametros.tab) {
                        case "0":
                            tabActivo = "pendientes";
                            break;
                        case "1":
                            tabActivo = "ruta";
                            break;
                        case "2":
                            tabActivo = "terminadas";
                            break;
                        case "3":
                            tabActivo = "estado";
                            break;
                    }
                    this.setState({ tabActivo });
                }
            }
        }
        else {
            Notificacion.error("Se debe seleccionar una empresa y call center en los parámetros para poder continuar.");
            this.props.history.replace(SiteRutas.Home);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.stopInterval();
    }

    obtenerContadores = async () => {
        if (this.props.token) {
            this.stopInterval();
            this.startInterval();
            const response = await Obtener_Conteo_Ordenes_Request(this.props.token, this.props.empresa.Id, this.props.callCenter.Id);
            if (response.Exitoso) {
                this._isMounted && this.setState({ contador: response.Datos, debeRefrescar: false });
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return false;
                }

                Notificacion.error(response.Mensaje);
                this._isMounted && this.setState({ debeRefrescar: false });
            }
        }
    }

    existenParametros = () => {
        return this.props.empresa && this.props.empresa.Id && this.props.callCenter && this.props.callCenter.Id;
    }

    startInterval() {
        this.timer = setInterval(() => {
            this.setState({ debeRefrescar: true }, () => {
                this.obtenerContadores();
            });
        }, 60000);
    }

    stopInterval() {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    }

    render() {
        if (!this.existenParametros()) {
            return null;
        }

        const { tabActivo, debeRefrescar } = this.state;

        return (
            <section className="padding-ordenes">
                <div className="row no-gutters">
                    <div className="col-12">
                        <Tabs
                            id="tabOrdenesEstado"
                            activeKey={tabActivo}
                            onSelect={(key) => this.setState({ tabActivo: key })}
                        >
                            <Tab eventKey="pendientes" title="Órdenes Pendientes">
                                <TabPanelBody
                                    estadoOrdenes="0" //PENDIENTES
                                    activo={tabActivo === 'pendientes'}
                                    debeRefrescar={debeRefrescar}
                                    mostrarFiltroEstatus={true}
                                    mostrarEstadosExpress={false}
                                    mostrarCalendario={true}
                                    tipoGrid="1"
                                    linkDetalle={SiteRutas.MonitorCallCenterDetalle}>
                                    <Accordion defaultActiveKey="0" className="accordion-status">
                                        <Card>
                                            <Card.Header>
                                                <Accordion.Toggle as={Button} variant="light" eventKey="0">
                                                    Estatus General de Órdenes
                                                </Accordion.Toggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="0">
                                                <Card.Body>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <div className="indicadores">
                                                                <Contador tipo="total" clase="pendiente" valor={this.state.contador.Total} texto="Órdenes Pendientes" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <div className="indicadores">
                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        <Contador tipo="normal" clase="aTiempo" valor={this.state.contador.A_Tiempo} texto="Órdenes a Tiempo" />
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <Contador tipo="normal" clase="medio" valor={this.state.contador.Tiempo_Medio} texto="Órdenes sobre tiempo Medio" />
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <Contador tipo="normal" clase="atrasada" valor={this.state.contador.Retrasadas} texto="Órdenes Retrasadas" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <div className="indicadores chart">
                                                                <Chart data={this.state.contador} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                </TabPanelBody>
                            </Tab>
                            <Tab eventKey="ruta" title="Órdenes en Ruta">
                                <TabPanelBody
                                    estadoOrdenes="1" //RUTA
                                    activo={tabActivo === 'ruta'}
                                    debeRefrescar={debeRefrescar}
                                    mostrarFiltroEstatus={true}
                                    mostrarEstadosExpress={false}
                                    mostrarCalendario={false}
                                    tipoGrid="2"
                                    linkDetalle={SiteRutas.MonitorCallCenterDetalle} />
                            </Tab>
                            <Tab eventKey="terminadas" title="Órdenes Terminadas">
                                <TabPanelBody
                                    estadoOrdenes="2" //TERMINADAS
                                    activo={tabActivo === 'terminadas'}
                                    debeRefrescar={debeRefrescar}
                                    mostrarFiltroEstatus={false}
                                    mostrarEstadosExpress={false}
                                    mostrarCalendario={true}
                                    tipoGrid="2"
                                    linkDetalle={SiteRutas.MonitorCallCenterDetalle} />
                            </Tab>
                            <Tab eventKey="estado" title="Órdenes por Estado">
                                <TabPanelBody
                                    estadoOrdenes="3" //ESTADO
                                    activo={tabActivo === 'estado'}
                                    debeRefrescar={debeRefrescar}
                                    mostrarFiltroEstatus={false}
                                    mostrarEstadosExpress={true}
                                    mostrarCalendario={true}
                                    tipoGrid="2"
                                    linkDetalle={SiteRutas.MonitorCallCenterDetalle} />
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </section>
        );
    }
};

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        callCenter: state.parametros.callCenter
    };
};

export default connect(mapStateToProps)(withRouter(memo(OrdenesPage)));